var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Emit, Inject, Prop, Vue, Watch, } from "vue-property-decorator";
import EditDataElementLabel from "../../components/articleattributes/editdataelementlabel.vue";
import { clone, } from "../utilities/aux";
import { isArray, isNumber, } from "../utilities/wsi4_typeguards";
let RotationDropDown = class RotationDropDown extends Vue {
    constructor() {
        super(...arguments);
        this.newValue = 0;
        this.selectedIndex = 0;
    }
    rotationChange(val) { return val; }
    onChange(event) {
        this.selectedIndex = event.target.selectedIndex;
        this.rotationChange(this.newRotationArray);
    }
    rotatedDegree(n) { return (n + 180) % 360.; }
    degreeString(n) { return n.toString() + "°"; }
    setNewValue(val) {
        if (val.length === 0) {
            this.selectedIndex = this.selectionMap.findIndex(m => m.free);
        }
        else if (Math.min(...val) === 0) {
            this.selectedIndex = this.selectionMap.findIndex(m => m.str.includes("0°"));
        }
        else if (Math.min(...val) === 90) {
            this.selectedIndex = this.selectionMap.findIndex(m => m.str.includes("90°"));
        }
        else {
            this.selectedIndex = this.selectionMap.findIndex(m => !m.free);
            this.newValue = val[0];
        }
    }
    cloneValue() {
        return clone(this.value, (arg) => isArray(arg, isNumber));
    }
    get elementKey() { return "fixedRotations"; }
    get showInfoIcon() { return this.networkBroker.configuration.editDataConfiguration[this.elementKey].showInfoIcon; }
    get invalid() { return !isNumber(this.newValue) || this.newValue < 0 || this.newValue >= 180.; }
    get newRotationArray() {
        if (this.selectionMap[this.selectedIndex].free) {
            if (this.selectionMap[this.selectedIndex].str.includes("90")) {
                return [
                    90,
                    this.rotatedDegree(90),
                ];
            }
            else if (this.selectionMap[this.selectedIndex].str.includes("0")) {
                return [
                    0,
                    this.rotatedDegree(0),
                ];
            }
            else {
                return [];
            }
        }
        else {
            return [
                this.newValue,
                this.rotatedDegree(this.newValue),
            ];
        }
    }
    get selectionMap() {
        const s = [
            {
                free: true,
                str: this.i18n.t("allRotations")
                    .toString(),
            },
            {
                free: true,
                str: this.degreeString(0),
            },
            {
                free: true,
                str: this.degreeString(90),
            },
        ];
        if (this.networkBroker.configuration.enableAnyRotation) {
            s.push({
                free: false,
                str: this.i18n.t("selectDegrees")
                    .toString(),
            });
        }
        return s;
    }
    get selectDegree() { return !this.selectionMap[this.selectedIndex].free; }
    created() { this.setNewValue(this.cloneValue()); }
    onValueChanged(val, _oldVal) {
        if (Math.min(...val) !== Math.min(...this.newRotationArray)) {
            this.setNewValue(this.cloneValue());
            this.rotationChange(this.newRotationArray);
        }
    }
    onNewValueChanged(val, _oldVal) {
        if (isNumber(val)) {
            this.rotationChange(this.newRotationArray);
        }
    }
};
__decorate([
    Prop({ required: true })
], RotationDropDown.prototype, "disabled", void 0);
__decorate([
    Prop({ required: true })
], RotationDropDown.prototype, "value", void 0);
__decorate([
    Inject()
], RotationDropDown.prototype, "i18n", void 0);
__decorate([
    Inject()
], RotationDropDown.prototype, "networkBroker", void 0);
__decorate([
    Emit()
], RotationDropDown.prototype, "rotationChange", null);
__decorate([
    Watch("value")
], RotationDropDown.prototype, "onValueChanged", null);
__decorate([
    Watch("newValue")
], RotationDropDown.prototype, "onNewValueChanged", null);
RotationDropDown = __decorate([
    Component({
        components: {
            EditDataElementLabel,
        },
        name: "RotationDropDown",
    })
], RotationDropDown);
export default RotationDropDown;
